import { render } from "./ApartmentsPendingApprovals.vue?vue&type=template&id=44ef5bb3"
import script from "./ApartmentsPendingApprovals.vue?vue&type=script&lang=js"
export * from "./ApartmentsPendingApprovals.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__